var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNearMeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.183 13.817 2.72 10.792a1.03 1.03 0 0 1-.547-.447A1.23 1.23 0 0 1 2 9.725q0-.316.187-.619a1.1 1.1 0 0 1 .562-.447L20.44 2.09q.347-.144.663-.058.317.087.548.317.23.231.317.548.086.316-.058.663l-6.57 17.69q-.143.375-.446.563a1.16 1.16 0 0 1-.62.187q-.316 0-.619-.173a1.03 1.03 0 0 1-.447-.547z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearMeFill);
export default __webpack_public_path__ + "static/media/near_me_fill.c98ed0ce1e022a0ae40e525eb793ef5e.svg";
export { ForwardRef as ReactComponent };